/**
 * 日期数量走势组件（曲线图）
 * zxw
 * 创建时间：2025-12-10
 * 更新时间：2026-05-08
 * 更新内容：优化数据处理
 */

import { useEffect, useRef, useMemo } from 'react';
import { Chart } from '@antv/g2';
import { Skeleton, theme, Empty } from 'antd';
import CNF from '../../../incs/Config.js';
import { NumberFormat } from '../../../incs/FunHelper.js';

const ChartLineDateCount = props => {
    const { children, id, title, subtitle, streamStatus } = props;

    const {
        token: {
            isDarkMode,
            colorPrimary,
        },
    } = theme.useToken();

    const chartIdRef = useRef(`${id || 'antv-g2-id'}.${Date.now()}`);
    const chartId = chartIdRef.current;

    const chartData = useMemo(() => {
        if (Array.isArray(children)) {
            return children;
        }
        if (typeof children === 'string') {
            try {
                return JSON.parse(children);
            } catch (err) {
                return [];
            }
        }
        return [];
    }, [children]);

    useEffect(() => {
        // 如果还在加载中或者没有有效数据，就不初始化图表
        if (streamStatus === 'loading') return;

        const div = document.getElementById(chartId);
        if (!div) return;
        const width = div.offsetWidth;

        const chart = new Chart({
            container: chartId,
            autoFit: true,
            height: width > 1000 ? 600 : 400,
            theme: isDarkMode ? 'classicDark' : 'classic',
        });

        // 设置标题
        if (title) {
            chart.title({
                title: title,
                subtitle: subtitle,
            });
        }

        // 格式化数据
        chart.data(chartData);

        chart
            .line()
            .encode('x', 'date')
            .encode('y', 'count')
            .encode('shape', 'smooth')
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '日期', })
            .axis('y', {
                title: '数量',
                labelFormatter: (d) => NumberFormat(d),
            })
            .animate('enter', {
                type: 'pathIn',
                duration: CNF.animateDuration + 1000,
            },)
            .tooltip({
                items: [(d => ({
                    name: '数量',
                    value: NumberFormat(d.count),
                }))]
            })
            .style('lineWidth', 1)
            .style('stroke', colorPrimary);

        chart.render();

        return () => {
            chart.destroy();
        }
    }, [children, streamStatus, chartId, isDarkMode]);

    // 加载时显示的骨架屏
    if (streamStatus === 'loading') {
        return <Skeleton.Image active={true} />;
    }

    // 数组为空，返回暂无数据
    if (chartData.length === 0) {
        return <Empty />;
    };

    return <div id={chartId}></div>
}

export default ChartLineDateCount;